import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";

const UpdateStatusModal = ({
      open,
      onClose,
      onUpdate,
      lead
}) => {
      const [status, setStatus] = useState("");

      useEffect(() => {
            if (lead) {
                  if (lead.status === "follow_up") {
                        setStatus("follow up");
                  } else {
                        setStatus(lead.status || "");
                  }
            }
      }, [lead]);

      const handleSubmit = () => {
            if (!status) return;

            onUpdate(lead.id, status);
      };

      return (
            <Modal
                  title="Update Status"
                  open={open}
                  onCancel={onClose}
                  onOk={handleSubmit}
                  okText="Update"
            >
                  <div>
                        <label>Status</label>
                        <Select
                              value={status}
                              onChange={(value) => setStatus(value)}
                              style={{ width: "100%", marginTop: "10px" }}
                              placeholder="Select Status"
                        >
                              <Select.Option value="Interested">Interested</Select.Option>
                              <Select.Option value="Completed">Completed</Select.Option>
                              <Select.Option value="Cancelled">Cancelled</Select.Option>
                        </Select>
                  </div>
            </Modal>
      );
};

export default UpdateStatusModal;